module.exports = __webpack_public_path__ + "static/media/cursos.67927af0.jpg";